import { saveAs } from "file-saver";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomDatePicker from "../../../components/main_comps/custom_date_picker";
import CustomSelect from "../../../components/main_comps/custom_select";

const statusOptions = [
  {
    label: "Settled",
    value: true,
  },
  {
    label: "Un Settled",
    value: false,
  },
];
const DownloadSettlementModal = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [clientName, setClientName] = useState("");
  const [selectedReseller, setSelectedReseller] = useState({});
  const [selectedClient, setSelectedClient] = useState({});

  const clientOptions = [{ label: "Client Name", value: "" }];
  const [selectedStatus, setSelectedStatus] = useState({});

  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const resellerList = useSelector(
    (state) => state.dropDownListSlice.resellerList
  );

  const { enqueueSnackbar } = useSnackbar();

  const onClickDownLoadReport = () => {
    if (
      (fromDate && toDate) ||
      selectedClient.value ||
      selectedReseller.value ||
      Object.keys(selectedStatus).length !== 0
    ) {
      ApiRequestGet.downloadSettlementList({
        userId: selectedClient.value,
        userRefId: selectedReseller.value,
        dateRange:
          fromDate && toDate
            ? moment(fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(toDate).format("DD/MM/YYYY")
            : "",
        status: selectedStatus.value,
      })
        .then((res) => {
          saveAs(res, "Commission.csv");
        })
        .catch((error) => {});
    } else {
      enqueueSnackbar("Please select a filter to download", {
        variant: "error",
      });
    }
  };
  return (
    <div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          From
        </label>
        <CustomDatePicker value={fromDate} onChange={setFromDate} />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          To
        </label>
        <CustomDatePicker value={toDate} onChange={setToDate} />
      </div>

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Client
        </label>

        <CustomSelect
          value={selectedClient}
          options={clientList}
          onChange={(data) => {
            setSelectedClient(data);
          }}
          placeholder={"Select client"}
        />
      </div>

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Reseller
        </label>

        <CustomSelect
          value={selectedReseller}
          options={resellerList}
          onChange={(data) => setSelectedReseller(data)}
          placeholder={"Select reseller "}
        />
      </div>

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Status
        </label>

        <CustomSelect
          value={selectedStatus}
          options={statusOptions}
          onChange={(data) => setSelectedStatus(data)}
          placeholder={"Status"}
        />
      </div>

      <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
        <CustomButton
          title="Download"
          backgroundColor="#38369C"
          styles={{ width: 150 }}
          onClick={() => {
            onClickDownLoadReport();
          }}
        />
      </div>
    </div>
  );
};

export default DownloadSettlementModal;
